import { css } from 'styled-components';

export default {
  wrapper: ({ size }) => css`
    position: relative;
    width: ${size}px;
    height: ${size}px;
  `,
  bar: ({
    color, thick, size, isLast
  }) => css`
    position: absolute;
    width: ${size}px;
    height: ${thick}px;
    background-color: ${color};
    transform: rotate(${isLast ? '-45deg' : '45deg'});
    top: ${(size - thick) / 2}px;
    left: 0;
  `,
};
